import { useMemo, type Dispatch, type SetStateAction } from "react"
import { useTranslation } from "react-i18next"
import { IconButton, Stack, Typography } from "@mui/material"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"

interface PaginationProps {
  count: number
  page: number
  setPage: Dispatch<SetStateAction<number>>
  limit?: number
}

const Pagination = ({ count, page, setPage, limit = 10 }: PaginationProps) => {
  const { t } = useTranslation()
  const pages = useMemo(() => Math.ceil(count / limit), [count, limit])
  const isFirstPage = useMemo(() => page === 0, [page])

  return count ? (
    <Stack direction={"row"} justifyContent={"end"} alignItems={"center"}>
      <IconButton
        size="small"
        sx={{ color: (theme) => theme.palette.text.primary }}
        disabled={isFirstPage}
        onClick={() => setPage(page - 1)}
        data-testid={"prev-arrow"}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Typography data-testid={"pages-info"}>{`${page + 1} ${t(
        "table.OF",
      )} ${pages}`}</Typography>
      <IconButton
        size="small"
        sx={{ color: (theme) => theme.palette.text.primary }}
        disabled={page + 1 === pages}
        onClick={() => setPage(page + 1)}
        data-testid={"next-arrow"}
      >
        <KeyboardArrowRightIcon />
      </IconButton>
    </Stack>
  ) : (
    <></>
  )
}

export default Pagination
